import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Badge, Button, Form, Card, FormCheck } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CustomerOrdersStore } from "../../../stores/CustomerOrdersStore";
import { STORE_CUSTOMER_ORDERS, STORE_REJECTIONS, SOURCES_AS61, SOURCES_AB61, SOURCES_ABTEKA } from "../../../constants";
import { RouteComponentProps, Link } from "react-router-dom";
import { formatDate, formatMoney } from "../../../common/Formatting";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { wrapInput, wrapCheckbox } from "../../../common/FormChangeWrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { MultiSelect } from "../../../common/UI/MultiSelect";
import { RejectionsStore } from "../../../stores";
import { LinkContainer } from "react-router-bootstrap";
registerLocale('ru', ru)

interface IProps {
    history: any;
    [STORE_CUSTOMER_ORDERS]: CustomerOrdersStore;
    [STORE_REJECTIONS]: RejectionsStore;
}

interface IState {
    currentPage: number,
    filterFormIsOpened: boolean,
    filteredManagerIds: string[],
    filteredCustomerId: string,
    dateFrom?: Date,
    dateTo?: Date,
    source?: string
    selectedPositionsIds: number[];
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_CUSTOMER_ORDERS, STORE_REJECTIONS)
@observer
export class RejectionsPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            filterFormIsOpened: false,
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            source: "",
            selectedPositionsIds: []
        };
    }

    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;
    rejectionsStore = (this.props as any)[STORE_REJECTIONS] as RejectionsStore;

    private backUrl = "";

    componentDidMount() {
        this.loadData();
        this.customerOrdersStore.loadManagers();
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        const prevPage = parseInt(prevProps.match.params.page) || 1;
        const page = parseInt(this.props.match.params.page) || 1;

        this.backUrl = encodeURIComponent("/sales/rejections/" + page);

        if (prevPage != page) {
            this.setState({
                currentPage: page
            }, () => {
                this.loadData();
            })
        }
    }

    loadData = () => {
        this.rejectionsStore.loadRejections(this.state.filteredManagerIds, this.state.filteredCustomerId, this.state.currentPage, this.state.source, this.state.dateFrom, this.state.dateTo);
    }

    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            dateFrom: undefined,
            dateTo: undefined
        });
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        });
    }

    private onCheckPosition = (fieldName: string, value: string, checked: boolean) => {

        let newSelectedPositions = this.state.selectedPositionsIds;
        const posId = parseInt(value);
        if (posId == -1) {
            if (checked) {
                newSelectedPositions = this.rejectionsStore.rejections.filter(w => !w.isReaded).map(w => w.id);
            }
            else
                newSelectedPositions = [];
        }
        else
            if (checked)
                newSelectedPositions.push(posId);
            else {
                newSelectedPositions.splice(newSelectedPositions.indexOf(posId), 1);
            }

        this.setState({
            selectedPositionsIds: newSelectedPositions
        })
    }

    private onSaveReading = () => {
        if (this.state.selectedPositionsIds.any())
            this.rejectionsStore.readRejections(this.state.selectedPositionsIds);
    }


    render() {
        return [
            <TablePageHeader header="Отказы" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" onClick={this.onSaveReading}>
                        <FontAwesomeIcon icon="eye" />
                        {' '}
                        Отметить прочитанным
                    </Button>
                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>
                                            <Form.Group controlId="filterForm.SelectSource">
                                                <Form.Label>Источник</Form.Label>
                                                <Form.Control as="select" size="sm"
                                                    value={this.state.source}
                                                    name="source"
                                                    onChange={wrapInput(this.changeFilter)}>

                                                    <option value="">Все</option>
                                                    <option value={SOURCES_AS61}>As61.ru</option>
                                                    <option value={SOURCES_AB61}>Ab61.ru</option>
                                                    <option value={SOURCES_ABTEKA}>Abteka.ru</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2">
                                            <Form.Group controlId="filterForm.SelectManager">
                                                <Form.Label>Ответственный</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Фильтр по менеджеру"
                                                    data={this.customerOrdersStore.managers}
                                                    selectedItems={this.state.filteredManagerIds}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredManagerIds", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key="2">
                <Col sm={12}>
                    <Table bordered striped className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">
                                    <FormCheck type="checkbox"
                                        value={"-1"}
                                        checked={this.state.selectedPositionsIds.length > 0 && this.state.selectedPositionsIds.length >= this.rejectionsStore.rejections.filter(w => !w.isReaded).length}
                                        onChange={wrapCheckbox(this.onCheckPosition)}
                                    />
                                </th>
                                <th className="text-center">Номер заказа</th>
                                <th className="text-center" style={{ width: "100px" }}>Дата заказа</th>
                                <th className="text-center" style={{ width: "230px" }}>Клиент</th>
                                <th className="text-center" style={{ width: "130px" }}>Бренд</th>
                                <th className="text-center">Артикул</th>
                                <th>Описание</th>
                                <th className="text-center">Менеджер</th>
                                <th className="text-center">Поставщик</th>
                                <th className="text-center" style={{ width: "100px" }}>Срок поставки</th>
                                <th className="text-center">Возвратность</th>
                                <th className="text-center">Статус</th>
                                <th className="text-center">Количество</th>
                                <th className="text-center">Цена</th>
                                <th className="text-center">Сумма</th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={13}
                            page={this.rejectionsStore.currentPage}
                            totalCount={this.rejectionsStore.totalOrdersCount}
                            pageSize={40}
                            move={"/sales/rejections"} />
                        <tbody>
                            {this.rejectionsStore.rejections.map((item, index) => <tr key={index}
                                className={item.isReaded ? "" : "table-warning"}>
                                <td className="text-center">
                                    {item.isReaded ? [] : <FormCheck type="checkbox"
                                        value={item.id.toString()}
                                        checked={this.state.selectedPositionsIds.indexOf(item.id) > -1}
                                        onClick={wrapCheckbox(this.onCheckPosition)}
                                    />}
                                </td>
                                <td className="text-center">
                                    <LinkContainer to={`/sales/orderdetails/${item.orderGuid}/${this.backUrl}`}>
                                        <Link to={`/sales/orderdetails/${item.orderGuid}/${this.backUrl}`}>{item.orderNumber}</Link>
                                    </LinkContainer>
                                </td>
                                <td className="text-center">{formatDate(item.dateCreate)}</td>
                                <td className="text-center">{item.customerName}</td>
                                <td className="text-center">{item.brand}</td>
                                <td className="text-center">{item.article}</td>
                                <td>{item.description}</td>
                                <td className="text-center">{item.managerName}</td>
                                <td className="text-center">{item.supplierName}</td>
                                <td className="text-center">{item.deliveryTimeString}</td>  
                                <td className="text-center">
                                    {item.isAllowDiscountRefund === null ? null
                                        : item.isAllowDiscountRefund ?
                                            <Badge variant="success">
                                                <FontAwesomeIcon icon="check" />
                                            </Badge>
                                            : <Badge variant="warning">
                                                <FontAwesomeIcon icon="times" />
                                            </Badge>
                                    }
                                </td>
                                <td className="text-center">{item.statusName} {item.statusRejected != null && item.statusRejected != item.statusName ? <span style={{ color: "#ee1940" }}>(Отказ)</span> : null}</td>
                                <td className="text-center">{item.count} {(item.rejectCount != null && item.rejectCount != item.count) ? <span style={{ color: "#ee1940" }}>{"(" + item.rejectCount + " отк.)"}</span> : null}</td>
                                <td className="text-center">{formatMoney(item.costSale)}</td>
                                <td className="text-center">{formatMoney(item.costSale * item.count)}</td>
                            </tr>)}
                        </tbody>

                    </Table>
                </Col>
            </Row>
        ]
    }

}